import React from 'react';
import {Copyright, FooterWrapper, SupportText} from './styles';
import {useLandingContext} from "../../../Landing";

export default function Footer() {
    const {APP_DATA} = useLandingContext();
    return (
        <FooterWrapper>
            <Copyright>{APP_DATA?.footer.copyright}</Copyright>
            <SupportText>{APP_DATA?.footer.support}</SupportText>
        </FooterWrapper>
    );
}
